import React, { useEffect, useState } from 'react';
import mainicon from '../../assets/finalicon.svg';
import Star from '../../components/star';
import uploadsvg from './businessassets/upload.svg';
import Sidebanner from './sidebanner';
import supabase from '../../supabase';
import FullPageLoader from '../../components/FullPageLoader';
import { useAuth } from '../../context/AuthContext'; 
import { Helmet } from 'react-helmet-async';

export default function Settingsbusiness() {

   const countriesList = [
  { code: "AF", name: "Afghanistan" },
  { code: "AL", name: "Albania" },
  { code: "DZ", name: "Algeria" },
  { code: "AS", name: "American Samoa" },
  { code: "AD", name: "Andorra" },
  { code: "AO", name: "Angola" },
  { code: "AI", name: "Anguilla" },
  { code: "AQ", name: "Antarctica" },
  { code: "AG", name: "Antigua and Barbuda" },
  { code: "AR", name: "Argentina" },
  { code: "AM", name: "Armenia" },
  { code: "AW", name: "Aruba" },
  { code: "AU", name: "Australia" },
  { code: "AT", name: "Austria" },
  { code: "AZ", name: "Azerbaijan" },
  { code: "BS", name: "Bahamas" },
  { code: "BH", name: "Bahrain" },
  { code: "BD", name: "Bangladesh" },
  { code: "BB", name: "Barbados" },
  { code: "BY", name: "Belarus" },
  { code: "BE", name: "Belgium" },
  { code: "BZ", name: "Belize" },
  { code: "BJ", name: "Benin" },
  { code: "BM", name: "Bermuda" },
  { code: "BT", name: "Bhutan" },
  { code: "BO", name: "Bolivia" },
  { code: "BQ", name: "Bonaire, Sint Eustatius and Saba" },
  { code: "BA", name: "Bosnia and Herzegovina" },
  { code: "BW", name: "Botswana" },
  { code: "BV", name: "Bouvet Island" },
  { code: "BR", name: "Brazil" },
  { code: "IO", name: "British Indian Ocean Territory" },
  { code: "BN", name: "Brunei Darussalam" },
  { code: "BG", name: "Bulgaria" },
  { code: "BF", name: "Burkina Faso" },
  { code: "BI", name: "Burundi" },
  { code: "CV", name: "Cabo Verde" },
  { code: "KH", name: "Cambodia" },
  { code: "CM", name: "Cameroon" },
  { code: "CA", name: "Canada" },
  { code: "KY", name: "Cayman Islands" },
  { code: "CF", name: "Central African Republic" },
  { code: "TD", name: "Chad" },
  { code: "CL", name: "Chile" },
  { code: "CN", name: "China" },
  { code: "CX", name: "Christmas Island" },
  { code: "CC", name: "Cocos (Keeling) Islands" },
  { code: "CO", name: "Colombia" },
  { code: "KM", name: "Comoros" },
  { code: "CG", name: "Congo" },
  { code: "CD", name: "Congo, Democratic Republic of the" },
  { code: "CK", name: "Cook Islands" },
  { code: "CR", name: "Costa Rica" },
  { code: "CI", name: "Côte d'Ivoire" },
  { code: "HR", name: "Croatia" },
  { code: "CU", name: "Cuba" },
  { code: "CW", name: "Curaçao" },
  { code: "CY", name: "Cyprus" },
  { code: "CZ", name: "Czech Republic" },
  { code: "DK", name: "Denmark" },
  { code: "DJ", name: "Djibouti" },
  { code: "DM", name: "Dominica" },
  { code: "DO", name: "Dominican Republic" },
  { code: "EC", name: "Ecuador" },
  { code: "EG", name: "Egypt" },
  { code: "SV", name: "El Salvador" },
  { code: "GQ", name: "Equatorial Guinea" },
  { code: "ER", name: "Eritrea" },
  { code: "EE", name: "Estonia" },
  { code: "SZ", name: "Eswatini" },
  { code: "ET", name: "Ethiopia" },
  { code: "FK", name: "Falkland Islands (Malvinas)" },
  { code: "FO", name: "Faroe Islands" },
  { code: "FJ", name: "Fiji" },
  { code: "FI", name: "Finland" },
  { code: "FR", name: "France" },
  { code: "GF", name: "French Guiana" },
  { code: "PF", name: "French Polynesia" },
  { code: "TF", name: "French Southern Territories" },
  { code: "GA", name: "Gabon" },
  { code: "GM", name: "Gambia" },
  { code: "GE", name: "Georgia" },
  { code: "DE", name: "Germany" },
  { code: "GH", name: "Ghana" },
  { code: "GI", name: "Gibraltar" },
  { code: "GR", name: "Greece" },
  { code: "GL", name: "Greenland" },
  { code: "GD", name: "Grenada" },
  { code: "GP", name: "Guadeloupe" },
  { code: "GU", name: "Guam" },
  { code: "GT", name: "Guatemala" },
  { code: "GG", name: "Guernsey" },
  { code: "GN", name: "Guinea" },
  { code: "GW", name: "Guinea-Bissau" },
  { code: "GY", name: "Guyana" },
  { code: "HT", name: "Haiti" },
  { code: "HM", name: "Heard Island and McDonald Islands" },
  { code: "VA", name: "Holy See" },
  { code: "HN", name: "Honduras" },
  { code: "HK", name: "Hong Kong" },
  { code: "HU", name: "Hungary" },
  { code: "IS", name: "Iceland" },
  { code: "IN", name: "India" },
  { code: "ID", name: "Indonesia" },
  { code: "IR", name: "Iran" },
  { code: "IQ", name: "Iraq" },
  { code: "IE", name: "Ireland" },
  { code: "IM", name: "Isle of Man" },
  { code: "IL", name: "Israel" },
  { code: "IT", name: "Italy" },
  { code: "JM", name: "Jamaica" },
  { code: "JP", name: "Japan" },
  { code: "JE", name: "Jersey" },
  { code: "JO", name: "Jordan" },
  { code: "KZ", name: "Kazakhstan" },
  { code: "KE", name: "Kenya" },
  { code: "KI", name: "Kiribati" },
  { code: "KP", name: "Korea, Democratic People's Republic of" },
  { code: "KR", name: "Korea, Republic of" },
  { code: "KW", name: "Kuwait" },
  { code: "KG", name: "Kyrgyzstan" },
  { code: "LA", name: "Lao People's Democratic Republic" },
  { code: "LV", name: "Latvia" },
  { code: "LB", name: "Lebanon" },
  { code: "LS", name: "Lesotho" },
  { code: "LR", name: "Liberia" },
  { code: "LY", name: "Libya" },
  { code: "LI", name: "Liechtenstein" },
  { code: "LT", name: "Lithuania" },
  { code: "LU", name: "Luxembourg" },
  { code: "MO", name: "Macao" },
  { code: "MG", name: "Madagascar" },
  { code: "MW", name: "Malawi" },
  { code: "MY", name: "Malaysia" },
  { code: "MV", name: "Maldives" },
  { code: "ML", name: "Mali" },
  { code: "MT", name: "Malta" },
  { code: "MH", name: "Marshall Islands" },
  { code: "MQ", name: "Martinique" },
  { code: "MR", name: "Mauritania" },
  { code: "MU", name: "Mauritius" },
  { code: "YT", name: "Mayotte" },
  { code: "MX", name: "Mexico" },
  { code: "FM", name: "Micronesia, Federated States of" },
  { code: "MD", name: "Moldova, Republic of" },
  { code: "MC", name: "Monaco" },
  { code: "MN", name: "Mongolia" },
  { code: "ME", name: "Montenegro" },
  { code: "MS", name: "Montserrat" },
  { code: "MA", name: "Morocco" },
  { code: "MZ", name: "Mozambique" },
  { code: "MM", name: "Myanmar" },
  { code: "NA", name: "Namibia" },
  { code: "NR", name: "Nauru" },
  { code: "NP", name: "Nepal" },
  { code: "NL", name: "Netherlands" },
  { code: "NC", name: "New Caledonia" },
  { code: "NZ", name: "New Zealand" },
  { code: "NI", name: "Nicaragua" },
  { code: "NE", name: "Niger" },
  { code: "NG", name: "Nigeria" },
  { code: "NU", name: "Niue" },
  { code: "NF", name: "Norfolk Island" },
  { code: "MP", name: "Northern Mariana Islands" },
  { code: "NO", name: "Norway" },
  { code: "OM", name: "Oman" },
  { code: "PK", name: "Pakistan" },
  { code: "PW", name: "Palau" },
  { code: "PS", name: "Palestine, State of" },
  { code: "PA", name: "Panama" },
  { code: "PG", name: "Papua New Guinea" },
  { code: "PY", name: "Paraguay" },
  { code: "PE", name: "Peru" },
  { code: "PH", name: "Philippines" },
  { code: "PN", name: "Pitcairn" },
  { code: "PL", name: "Poland" },
  { code: "PT", name: "Portugal" },
  { code: "PR", name: "Puerto Rico" },
  { code: "QA", name: "Qatar" },
  { code: "RE", name: "Réunion" },
  { code: "RO", name: "Romania" },
  { code: "RU", name: "Russian Federation" },
  { code: "RW", name: "Rwanda" },
  { code: "BL", name: "Saint Barthélemy" },
  { code: "SH", name: "Saint Helena, Ascension and Tristan da Cunha" },
  { code: "KN", name: "Saint Kitts and Nevis" },
  { code: "LC", name: "Saint Lucia" },
  { code: "MF", name: "Saint Martin (French part)" },
  { code: "PM", name: "Saint Pierre and Miquelon" },
  { code: "VC", name: "Saint Vincent and the Grenadines" },
  { code: "WS", name: "Samoa" },
  { code: "SM", name: "San Marino" },
  { code: "ST", name: "Sao Tome and Principe" },
  { code: "SA", name: "Saudi Arabia" },
  { code: "SN", name: "Senegal" },
  { code: "RS", name: "Serbia" },
  { code: "SC", name: "Seychelles" },
  { code: "SL", name: "Sierra Leone" },
  { code: "SG", name: "Singapore" },
  { code: "SX", name: "Sint Maarten (Dutch part)" },
  { code: "SK", name: "Slovakia" },
  { code: "SI", name: "Slovenia" },
  { code: "SB", name: "Solomon Islands" },
  { code: "SO", name: "Somalia" },
  { code: "ZA", name: "South Africa" },
  { code: "GS", name: "South Georgia and the South Sandwich Islands" },
  { code: "SS", name: "South Sudan" },
  { code: "ES", name: "Spain" },
  { code: "LK", name: "Sri Lanka" },
  { code: "SD", name: "Sudan" },
  { code: "SR", name: "Suriname" },
  { code: "SJ", name: "Svalbard and Jan Mayen" },
  { code: "SE", name: "Sweden" },
  { code: "CH", name: "Switzerland" },
  { code: "SY", name: "Syrian Arab Republic" },
  { code: "TW", name: "Taiwan, Province of China" },
  { code: "TJ", name: "Tajikistan" },
  { code: "TZ", name: "Tanzania, United Republic of" },
  { code: "TH", name: "Thailand" },
  { code: "TL", name: "Timor-Leste" },
  { code: "TG", name: "Togo" },
  { code: "TK", name: "Tokelau" },
  { code: "TO", name: "Tonga" },
  { code: "TT", name: "Trinidad and Tobago" },
  { code: "TN", name: "Tunisia" },
  { code: "TR", name: "Turkey" },
  { code: "TM", name: "Turkmenistan" },
  { code: "TC", name: "Turks and Caicos Islands" },
  { code: "TV", name: "Tuvalu" },
  { code: "UG", name: "Uganda" },
  { code: "UA", name: "Ukraine" },
  { code: "AE", name: "United Arab Emirates" },
  { code: "GB", name: "United Kingdom" },
  { code: "US", name: "United States" },
  { code: "UM", name: "United States Minor Outlying Islands" },
  { code: "UY", name: "Uruguay" },
  { code: "UZ", name: "Uzbekistan" },
  { code: "VU", name: "Vanuatu" },
  { code: "VE", name: "Venezuela" },
  { code: "VN", name: "Viet Nam" },
  { code: "VG", name: "Virgin Islands, British" },
  { code: "VI", name: "Virgin Islands, U.S." },
  { code: "WF", name: "Wallis and Futuna" },
  { code: "EH", name: "Western Sahara" },
  { code: "YE", name: "Yemen" },
  { code: "ZM", name: "Zambia" },
  { code: "ZW", name: "Zimbabwe" }
];
 const { business, setBusiness, loading: authLoading } = useAuth();
  const [toast, setToast] = useState({ message: '', type: '' });
  const [uploading, setUploading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [passLoading, setPassLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  // CONSOLIDATED FORM STATE
  const [formData, setFormData] = useState({
    about: '', email: '', phone: '', country: '',
    address1: '', address3: '', address4: '',
  });

 const [passwords, setPasswords] = useState({
  current: '', // ADDED THIS
  new: '',
  confirm: ''
});

  const notify = (message, type = 'success') => {
    setToast({ message, type });
    setTimeout(() => setToast({ message: '', type: '' }), 3000);
  };

  useEffect(() => {
    if (business) {
      setFormData({
        about: business.about || '',
        email: business.email || '',
        phone: business.phone || '',
        country: business.country || '',
        address1: business.address1 || '',
        address3: business.address3 || '',
        address4: business.address4 || '',
      });
    }
  }, [business]);

  if (authLoading || !business) return <FullPageLoader />;

  // --- PASSWORD UPDATE LOGIC ---
  const handleUpdatePassword = async () => {
  if (passwords.new.length < 8) {
    notify("New password must be at least 8 characters", "error");
    return;
  }
  if (passwords.new !== passwords.confirm) {
    notify("New passwords do not match", "error");
    return;
  }

  setPassLoading(true);
  try {
    // STEP 1: Verify the current password
    const { error: reAuthError } = await supabase.auth.signInWithPassword({
      email: business.email,
      password: passwords.current,
    });

    if (reAuthError) {
      throw new Error("Current password is incorrect.");
    }

    // STEP 2: Update to the new password
    const { error: updateError } = await supabase.auth.updateUser({
      password: passwords.new
    });

    if (updateError) throw updateError;

    notify("Password updated successfully");
    setPasswords({ current: '', new: '', confirm: '' });
  } catch (err) {
    notify(err.message, "error");
  } finally {
    setPassLoading(false);
  }
};

  // --- PROFILE UPDATE LOGIC ---
  async function uploadImage(event) {
    setUploading(true);
    const file = event.target.files[0];
    if (!file) { setUploading(false); return; }
    const fileExt = file.name.split('.').pop();
    const fileName = `${business.id}_${Date.now()}.${fileExt}`;
    const filePath = `companyimages/${fileName}`;

    try {
      const { error: uploadError } = await supabase.storage.from('companyimages').upload(filePath, file);
      if (uploadError) throw uploadError;
      const publicUrl = `https://wnjcqclqpgqdyyomobeh.supabase.co/storage/v1/object/public/companyimages/${filePath}`;
      const { data: updatedBusiness, error: updateError } = await supabase.from('businesses').update({ img: publicUrl }).eq('id', business.id).select().single();
      if (updateError) throw updateError;
      setBusiness(updatedBusiness);
      notify("Logo updated");
    } catch (err) {
      notify(err.message, "error");
    } finally {
      setUploading(false);
    }
  }

  const handleSaveAll = async () => {
    setLoading(true);
    try {
      if (formData.email !== business.email) {
        const { error: authError } = await supabase.auth.updateUser({ email: formData.email });
        if (authError) throw authError;
      }
      const { data: updatedBusiness, error } = await supabase.from('businesses').update(formData).eq('id', business.id).select().single();
      if (error) throw error;
      setBusiness(updatedBusiness); 
      notify("Settings updated"); 
    } catch (error) {
      notify(error.message || 'Failed to save changes.', 'error');
    } finally {
      setLoading(false);
    }
  };

  const customRound = (rating) => {
    const rounded = parseFloat(rating);
    if (isNaN(rounded)) return 0;
    const decimal = rounded % 1;
    return decimal < 0.25 ? Math.floor(rounded) : decimal < 0.75 ? Math.floor(rounded) + 0.5 : Math.ceil(rounded);
  };

  const getStarColor = (rounded) => {
    const colors = { 5: 'bg-five', 4.5: 'bg-fourhalf', 4: 'bg-four', 3.5: 'bg-threehalf', 3: 'bg-three', 2.5: 'bg-twohalf', 2: 'bg-two', 1.5: 'bg-onehalf', 1: 'bg-one' };
    return colors[rounded] || 'bg-gray-300';
  };

  return (
    <div className="min-h-screen w-full bg-[#F8FAFB] flex flex-col lg:pr-[300px] pb-20">
      <Helmet>
        <title>Settings | Sitemanifest</title> 
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="w-full bg-white border-b border-gray-200 pt-[100px] px-6 py-10">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-2xl font-bold text-gray-900 font-poppins">Account & Business Settings</h1>
          <p className="text-sm text-gray-500 mt-1">Update your credentials and public business presence.</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto w-full px-4 mt-8 space-y-8">
        {/* Profile Card */}
        <section className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
          <div className="bg-[#1E7D6B] px-6 py-3 flex items-center gap-3">
            <img className="w-5" src={mainicon} alt="" />
            <h2 className="font-staat text-sm tracking-[3px] text-white uppercase">SITEMANIFEST</h2>
          </div>
          <div className="p-6 flex flex-col sm:flex-row items-center sm:items-start gap-6">
            <div className="relative group">
              <div className="w-24 h-24 rounded-lg bg-gray-900 overflow-hidden border-4 border-gray-50 shadow-md flex items-center justify-center">
                {business.img ? <img className="w-full h-full object-cover" src={business.img} alt="Logo" /> : <span className="text-3xl font-bold uppercase text-white">{business.title?.[0]}</span>}
              </div>
              <label className="absolute -bottom-2 -right-2 bg-white p-1.5 rounded-full shadow-lg border border-gray-200 cursor-pointer hover:bg-gray-50">
                <img src={uploadsvg} className="w-5 h-5 opacity-70" alt="upload" />
                <input type="file" accept="image/*" onChange={uploadImage} disabled={uploading} className="hidden" />
              </label>
            </div>
            <div className="flex-1 text-center sm:text-left">
              <h3 className="text-xl font-bold text-gray-900">{business.title}</h3>
              <div className="flex justify-center sm:justify-start items-center gap-3 mt-2">
                <div className="flex gap-1">
                  {Array(5).fill().map((_, i) => {
                    const starValue = customRound(parseFloat(business.trustscore));
                    const isFullStar = i < Math.floor(starValue);
                    const isHalfStar = i === Math.floor(starValue) && starValue % 1 >= 0.5;
                    return <Star key={i} boxwidth={'w-5'} boxheight={'h-5'} width={'w-3'} bgColor={isFullStar ? getStarColor(starValue) : 'bg-gray-300'} half={isHalfStar} halfStar={isHalfStar ? getStarColor(starValue) : 'bg-gray-300'} />;
                  })}
                </div>
                <span className="text-sm font-semibold text-gray-700">{business?.trustscore?.toFixed(1)}</span>
                <span className="text-sm text-gray-500">({business?.reviews} Reviews)</span>
              </div>
            </div>
          </div>
        </section>

        {/* --- SECURITY (NEW) --- */}
<section className="space-y-4">
  <h3 className="text-lg font-semibold text-gray-800">Security</h3>
  <div className="bg-white p-6 rounded-xl border border-gray-200">
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <div className="space-y-1">
        <label className="text-[10px] font-bold text-gray-400 uppercase ml-1">Current Password</label>
        <input 
          type="password" 
          placeholder="••••••••" 
          value={passwords.current} 
          onChange={e => setPasswords({...passwords, current: e.target.value})} 
          className="w-full border rounded-lg px-4 py-2 text-sm focus:ring-2 focus:ring-[#1C6065] outline-none" 
        />
      </div>
      <div className="space-y-1">
        <label className="text-[10px] font-bold text-gray-400 uppercase ml-1">New Password (8+)</label>
        <input 
          type="password" 
          placeholder="••••••••" 
          value={passwords.new} 
          onChange={e => setPasswords({...passwords, new: e.target.value})} 
          className="w-full border rounded-lg px-4 py-2 text-sm focus:ring-2 focus:ring-[#1C6065] outline-none" 
        />
      </div>
      <div className="space-y-1">
        <label className="text-[10px] font-bold text-gray-400 uppercase ml-1">Repeat New</label>
        <input 
          type="password" 
          placeholder="••••••••" 
          value={passwords.confirm} 
          onChange={e => setPasswords({...passwords, confirm: e.target.value})} 
          className="w-full border rounded-lg px-4 py-2 text-sm focus:ring-2 focus:ring-[#1C6065] outline-none" 
        />
      </div>
    </div>
    <button 
      onClick={handleUpdatePassword} 
      disabled={passLoading || !passwords.new || !passwords.current} 
      className="mt-4 px-6 bg-gray-900 text-white py-2 rounded-lg text-sm font-bold hover:bg-black transition-all disabled:opacity-50"
    >
      {passLoading ? 'Verifying & Updating...' : 'Securely Update Password'}
    </button>
  </div>
</section>

        {/* Identity & Contact */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <section className="space-y-4">
            <h3 className="text-lg font-semibold text-gray-800">Identity</h3>
            <div className="bg-white p-6 rounded-xl border border-gray-200 space-y-4">
              <label className="block text-xs font-bold text-gray-500 uppercase">Company Name</label>
              <input value={business.title} readOnly className="w-full bg-gray-50 border rounded-lg px-4 py-2 text-sm text-gray-400" />
              <label className="block text-xs font-bold text-gray-500 uppercase">Website</label>
              <input value={business.www} readOnly className="w-full bg-gray-50 border rounded-lg px-4 py-2 text-sm text-gray-400" />
            </div>
          </section>
          <section className="space-y-4">
            <h3 className="text-lg font-semibold text-gray-800">Communication</h3>
            <div className="bg-white p-6 rounded-xl border border-gray-200 space-y-4">
              <input placeholder="Email" value={formData.email} onChange={e => setFormData({...formData, email: e.target.value})} className="w-full border rounded-lg px-4 py-2 text-sm" />
              <input placeholder="Phone" value={formData.phone} onChange={e => setFormData({...formData, phone: e.target.value})} className="w-full border rounded-lg px-4 py-2 text-sm" />
            </div>
          </section>
        </div>

        {/* Narrative */}
        <section className="space-y-4">
          <h3 className="text-lg font-semibold text-gray-800">About</h3>
          <textarea value={formData.about} onChange={e => setFormData({...formData, about: e.target.value})} className="w-full h-44 p-4 border rounded-lg text-sm resize-none" placeholder="Description..." />
        </section>

        {/* Location */}
        <section className="space-y-4">
          <h3 className="text-lg font-semibold text-gray-800">Location</h3>
          <div className="bg-white p-6 rounded-xl border border-gray-200 grid grid-cols-1 md:grid-cols-2 gap-4">
            <select value={formData.country} onChange={e => setFormData({...formData, country: e.target.value})} className="border rounded-lg px-4 py-2 text-sm">
              <option value="">Select Country</option>
              {countriesList.map(c => <option key={c.code} value={c.name}>{c.name}</option>)}
            </select>
            <input placeholder="City" value={formData.address1} onChange={e => setFormData({...formData, address1: e.target.value})} className="border rounded-lg px-4 py-2 text-sm" />
            <input placeholder="Street" value={formData.address3} onChange={e => setFormData({...formData, address3: e.target.value})} className="border rounded-lg px-4 py-2 text-sm" />
            <input placeholder="Zip" value={formData.address4} onChange={e => setFormData({...formData, address4: e.target.value})} className="border rounded-lg px-4 py-2 text-sm" />
          </div>
        </section>

        <div className="pt-6 flex flex-col items-center gap-4">
          <button onClick={handleSaveAll} disabled={loading} className="w-full md:w-64 bg-[#1C6065] text-white py-3 rounded-lg font-bold hover:bg-[#154a4e] transition-all">
            {loading ? 'Saving...' : 'Save All Business Settings'}
          </button>
        </div>
      </div>

  
        <Sidebanner />

      {toast.message && (
        <div className={`fixed top-10 left-1/2 -translate-x-1/2 px-6 py-3 rounded-xl shadow-2xl z-[9999] font-jakarta text-[14px] font-bold tracking-tight flex items-center gap-3 animate-slide-down border transition-all ${
          toast.type === 'error' ? 'bg-white border-red-200 text-red-600' : 'bg-[#25c673] border-emerald-400 text-white'
        }`}>
          <div className={`w-2 h-2 rounded-full animate-pulse ${toast.type === 'error' ? 'bg-red-500' : 'bg-white'}`}></div>
          {toast.message}
        </div>
      )}

      <style>{`
        @keyframes slide-down { 0% { transform: translate(-50%, -20px); opacity: 0; } 100% { transform: translate(-50%, 0); opacity: 1; } }
        .animate-slide-down { animation: slide-down 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
      `}</style>
    </div>
  );
}